import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},0.8)`} fill="none">
      <path
        d="M10.53 100.58H60.19C60.19 100.58 67.33 79.8699 67.68 44.7699C68.03 9.6699 62.84 1.41992 62.84 1.41992H7.20002C7.20002 1.40992 -8.41998 52.49 10.53 100.58Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
